<template>
  <div class="flex flex-1">
    <!-- {{ v2 }} -->
    <!-- <ejs-multiselect
      v-if="v2"
      id="multiselect"
      :dataSource="dataSource"
      v-model="selectedUnits"
      :fields="f"
      :popupHeight="popupHeight"
      enableGroupCheckBox="true"
      showDropDownIcon="true"
      allowFiltering="true"
      filterType="contains"
      filterBarPlaceholder="Search"
      showSelectAll="true"
      placeholder="Select Assets"
      :filtering="filtering"
      :disable="disable"
      :maximumSelectionLength="singleSelect ? 1 : dataSource.length"
    /> -->
    <!-- <FuseSelect v-else :value="selectedUnits" @input="$emit('input', $event)" /> -->
    <!-- <div>{{ selectedUnits }}</div> -->
    <div v-if="!v2" class="w-full">
      <FuseMultiselect
        placeholder="Select Assets"
        :data="dataSource"
        :multiple="!singleSelect"
        :fields="f"
        :value="value"
        @input="(v) => $emit('input', v)"
      />
    </div>
  </div>
</template>

<script>
import FuseMultiselect from './FuseMultiselect.vue';
import { Query, Predicate } from '@syncfusion/ej2-data';
export default {
  components: { FuseMultiselect },
  props: {
    value: {},
    dataSource: {
      default() {
        return JSON.parse(localStorage.getItem('unitSelection'));
      },
    },
    popupHeight: { default: '400px' },
    v2: { default: false },
    disable: { default: false },
    singleSelect: { default: undefined },
    f: {
      default() {
        return { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' };
      },
    },
    filtering: {
      type: Function,
      default: function (args) {
        console.log('Default filtering function triggered', args);
        let query = new Query();
        if (args.text) {
          const predicate = new Predicate('name', 'contains', args.text, true);
          query = query.where(predicate);
        }
        args.updateData(this.props.dataSource, query);
      },
    },
    isLegacy: { default: true },
    initialSelect: { default: undefined },
  },
  data() {
    return {
      dontEmit: false,
      // unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      selectedUnits: [],
      // fields: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
    };
  },
  methods: {
    // filtering(args) {
    //   const self = this;
    //   const searchData = self.unitSelection;
    //   let query = new Query();
    //   let predicate = new Predicate('assetName', 'contains', args.text, true);
    //   predicate = predicate.or('assetGroup', 'contains', args.text, true);
    //   query = args.text != '' ? query.where(predicate) : query;

    //   args.updateData(searchData, query);
    // },
    clearSelected() {
      this.dontEmit = true;
      this.selectedUnits = [];
      if (this.$route.name == 'map' && this.$route.params.assetId) {
        this.selectedUnits = [Number(this.$route.params.assetId)];
      }
      if (this.$route.name == 'monitor' && this.$route.params.assetId) {
        this.selectedUnits = [Number(this.$route.params.assetId)];
      }
      if (this.$route.name == 'playback' && this.$route.params.assetId) {
        let index = this.dataSource.findIndex(
          (val) => val.assetId == this.$route.params.assetId,
        );
        if (index != -1) {
          this.selectedUnits.push(this.dataSource[index].unitId);
        }
      }
      this.dontEmit = false;
    },
    manualClear() {
      this.dontEmit = true;
      this.selectedUnits = [];
      this.dontEmit = false;
    },
  },
};
</script>

<style scoped></style>
